<div *ngIf="(mail$ | async) as mail" class="sh-contained-eml">
    <h3>{{'viewer.eml.subject' | translate }}: {{mail.subject}}</h3>

    <div *ngIf="mail.html" [innerHTML]="mail.html | safeHtml"></div>
    <pre *ngIf="!mail.html">{{mail?.text?.trim()}}</pre>

</div>
